import styled, { css } from 'styled-components'

import {
  color,
  ColorKeys,
  gap,
  GapProps,
  space,
  SpaceProps,
  Theme,
  typography,
} from '../../themes'

interface ContainerProps extends SpaceProps, GapProps {
  variant: keyof Theme['typography']
  textColor?: ColorKeys<Theme>
  textAlign?: 'left' | 'center' | 'right'
  wordBreak?: 'normal' | 'break-all'
  inlineFlex?: boolean
}

export const Container = styled.span<ContainerProps>`
  ${space}
  ${gap}

  ${({ inlineFlex }) =>
    inlineFlex &&
    css`
      display: inline-flex;
    `}

  ${({ variant }) => typography(variant)};

  ${({ textAlign }) =>
    textAlign &&
    css`
      text-align: ${textAlign};
    `};

  ${({ textColor }) =>
    textColor &&
    css`
      color: ${color(textColor)};
    `};

  ${({ wordBreak }) =>
    wordBreak &&
    css`
      word-break: ${wordBreak};
    `};
`
